const PERMISSION_KEY= "core:authz_permission_group_mapping";
const PAGE_URL = {
    AUTHZ_PERMISSION_GROUP_MAPPING_PAGE: "/admin/core/authz-permission-group-mapping"
}

export {PERMISSION_KEY, PAGE_URL}

